import { OnInit, OnDestroy, Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { FlatPickrDirective } from '../../plugins/flatpickr/flatpickr.directive';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { WeGoConfig } from '../../shared/config';


const moment = require("moment");

@Component({
  selector: 'wego-snail-trail-driver-filter',
  template: require('../views/snail-trail-driver-filter.component.html'),
  styles: [`
    .nopad-left{
      padding-left: 0px;
    } 
  `]
})
export class SnailTrailDriverFilterComponent implements OnInit, OnDestroy {
  
  @Output('OnSearch') onSearchEvent = new EventEmitter();
  @Output('OnExportXls') onExportXls = new EventEmitter();
  @Output('OnResetData') onResetData = new EventEmitter();

  @Input('IsValidReport') isValidReport: boolean = false;

  @Input()
  set ErrorModel(errorModel: any) {
    this.errorModel = errorModel;
  }
  get ErrorModel() { return this.errorModel; }

  driverhashId: string;
  bookingRefrenceId: string;
  bookingHashId: string;
  licenceTag: string;
  vehicleHashId: string;
   
  errorModel: any;

  ngOnInit(): void {
  
  }

  public SuccessSelectDriverModal($event: any) {
    this.driverhashId = $event.DriverHashID;
    
    this.OnFilterReset();
  }
  public SuccessSelectBookingModal($event: any) {
    this.bookingRefrenceId = $event.BookingReferenceId;
    this.bookingHashId = $event.BookingHashID;
    this.driverhashId = $event.DriverHashID;    
    this.licenceTag = $event.LicenceTage;
    this.vehicleHashId = $event.VehicleMasterHashID;
    this.OnFilterReset();
  }
  public SuccessSelectVehicleModal($event: any) {
    this.licenceTag = $event.LicenceTage;
    this.vehicleHashId = $event.VehicleMasterHashID;
    this.OnFilterReset();
  }

  public OnFilterReset() {
    this.onResetData.emit();
  }

  public OnSearchChange() {
    this.bookingRefrenceId = "";
    this.bookingHashId = "";
    this.driverhashId = "";    
    this.licenceTag = "";
    this.vehicleHashId = "";    
    this.onResetData.emit();
  }

  OnSearch($event: any) {
    this.onSearchEvent.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
  }

  OnExportXls($event: any) {
    this.onExportXls.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
  }
  ngOnDestroy(): void {

  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/snail-trail-driver/components/snail-trail-driver-filter.component.ts